module.exports = __webpack_public_path__ + "images/emoji/sweat_drops.245c349238cdf4f0951b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/sweat_drops.png
// module id = SPzM
// module chunks = 24